import { render } from "./AllCocktailsView.vue?vue&type=template&id=79c04164&scoped=true"
import script from "./AllCocktailsView.vue?vue&type=script&lang=js"
export * from "./AllCocktailsView.vue?vue&type=script&lang=js"

import "./AllCocktailsView.vue?vue&type=style&index=0&id=79c04164&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79c04164"]])

export default __exports__